import { eventBus } from './eventBus'

/**
 * 결제창 단독 실행일 경우 내부 팝업이 닫힐때 포커몰을 하기 위한 기능
 */
export function mallClose() {
  if ($('.mi6-mall').hasClass('only-payment')) {
    eventBus.trigger('mallRemove')
  }
}
